export default function ConvertToShortHandHeight(longFormHeightString) {
  if (!longFormHeightString){
    return ''
  }

  const heightFt = longFormHeightString.match(/\d/g)[0];
  const heightIn = `${longFormHeightString.match(/\d/g)[1]}${longFormHeightString.match(/\d/g)[2] || ''}`;

  return `${heightFt}'${heightIn}"`
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/ShortHandHeight.js